// src/graphql/queries/userQueries.js

export const getUsers = () => `query GetUsers($companyId: String, $role: UserRole, $active: Boolean, $limit: Int, $offset: Int) {
    adminUsers(companyId: $companyId, role: $role, active: $active, limit: $limit, offset: $offset) {
        id
        email
        firstName
        lastName
        companyId
        role
        jobTitle
        avatar
        active
        lastLogin
        isCompanyRepresentative
        createdAt
        updatedAt
        company {
            id
            name
            size
            industry
        }
    }
}`;

export const getUser = () => `query GetUser($id: String!) {
    adminUser(id: $id) {
        id
        email
        firstName
        lastName
        companyId
        role
        jobTitle
        avatar
        active
        lastLogin
        isCompanyRepresentative
        createdAt
        updatedAt
        company {
            id
            name
            size
            industry
            location {
                address
                city
                state
                postalCode
                country
                nutsCode
                latitude
                longitude
            }
            website
            description
        }
    }
}`;

export const getImpersonationInfo = () => `query GetImpersonationInfo {
    impersonationInfo {
        isImpersonation
        impersonatedBy {
            id
            email
            firstName
            lastName
        }
        impersonatedUser {
            id
            email
            firstName
            lastName
        }
    }
}`;
